import axios from "axios";
import { API_URL, getHeaders } from "../config";

const onAuthError = (error) => {
  const status = error?.response?.status;
  if (status === 401 || status === 403) {
    localStorage.removeItem("token");
    window.location.href = "/";
  }
};

// When voice training is switched off the API answers 404, which lands in the
// catch below as an empty list.
export const getMyVoiceTraining = async () => {
  try {
    const { data } = await axios.get(`${API_URL}/api/voice-training/me`, {
      headers: getHeaders().headers,
    });
    return data?.data ?? [];
  } catch (error) {
    onAuthError(error);
    return [];
  }
};

// Returns the one-time ChatPilot URL, or throws with a message the learner can read.
export const getVoiceLaunchUrl = async (assignmentId) => {
  try {
    const { data } = await axios.post(
      `${API_URL}/api/voice-training/launch/${assignmentId}`,
      {},
      { headers: getHeaders().headers }
    );
    return data?.data?.url;
  } catch (error) {
    onAuthError(error);
    throw new Error(
      error?.response?.data?.message || "Voice training is unavailable right now."
    );
  }
};
